import { render, staticRenderFns } from "./PrmIndustry.vue?vue&type=template&id=019f4bf1&scoped=true&"
import script from "./PrmIndustry.vue?vue&type=script&lang=js&"
export * from "./PrmIndustry.vue?vue&type=script&lang=js&"
import style0 from "./PrmIndustry.vue?vue&type=style&index=0&id=019f4bf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f4bf1",
  null
  
)

component.options.__file = "PrmIndustry.vue"
export default component.exports